module.exports = __webpack_public_path__ + "static/media/policy.5827cf03.png";